export default "__VITE_ASSET__CW1CBfa0__"